import styled from "styled-components";

export const StyledDiv = styled.div`
  .Polaris-LegacyStack {
    flex-wrap: nowrap;
  }
`;
